import { Form, Button, Col, Row, Space, Select, Typography } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import Title from 'antd/lib/typography/Title';
import { useEffect, useState } from 'react';

interface ExpenseBulkEditComponentProps {
  onUpdate: (data: any) => void;
  onCancel: () => void;
  expenseCommon: any;
  selectedExpenses: number[];
}

const { Option } = Select;

function ExpenseBulkEditComponent({
  onUpdate,
  onCancel,
  expenseCommon,
  selectedExpenses,
}: ExpenseBulkEditComponentProps) {
  const [form] = Form.useForm();
  const [mount, setMount] = useState(true);
  const [projectList, setProjectList] = useState<any[]>();
  const [gongjongList, setGongjongList] = useState<any[]>();
  const [categoryList, setCategoryList] = useState<any[]>();

  useEffect(() => {
    if (!mount) return;
    let children: any = [];
    for (const project of expenseCommon.projectList.sort((a: any, b: any) =>
      b.startDate.localeCompare(a.startDate),
    )) {
      children.push(
        <Option key={project.id} value={project.id}>
          {project.name}
        </Option>,
      );
    }
    setProjectList(children);
    children = [];
    for (const category of expenseCommon.categoryList.sort((a: any, b: any) =>
      a.name.localeCompare(b.name),
    )) {
      children.push(
        <Option key={category.id} value={category.name}>
          {category.name}
        </Option>,
      );
    }
    setCategoryList(children);

    children = [];
    for (const gongjong of expenseCommon.gongjongList.sort((a: any, b: any) =>
      a.name.localeCompare(b.name),
    )) {
      children.push(
        <Option key={gongjong.id} value={gongjong.name}>
          {gongjong.name}
        </Option>,
      );
    }
    setGongjongList(children);

    return () => setMount(false);
  }, [expenseCommon, mount]);

  return (
    <>
      <Row>
        <Col flex={1}>
          <Title level={3}>지출 등록</Title>
        </Col>
      </Row>
      <Row style={{ marginBottom: '20px' }}>
        <Col flex={1}>
          <Typography.Text>
            {selectedExpenses.length}개의 지출이 선택되었습니다.
          </Typography.Text>
        </Col>
      </Row>
      <Form form={form} layout="vertical" onFinish={onUpdate}>
        <Row justify="space-between">
          <Col span={11}>
            <Form.Item name="gongjong" label="공사종류">
              <Select style={{ width: '100%' }} allowClear>
                {gongjongList}
              </Select>
            </Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item
              name="category"
              label="용도"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select style={{ width: '100%' }}>{categoryList}</Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col flex={1}>
            <Form.Item
              name={['project', 'id']}
              label="프로젝트"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select style={{ width: '100%' }}>{projectList}</Select>
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col flex={1}>
            <Form.Item name="description" label="설명">
              <TextArea rows={4} />
            </Form.Item>
          </Col>
        </Row>

        <Row justify="center">
          <Form.Item>
            <Space size="middle">
              <Button htmlType="button" onClick={onCancel}>
                취소
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                style={{ width: '100px' }}
              >
                확인
              </Button>
            </Space>
          </Form.Item>
        </Row>
      </Form>
    </>
  );
}
export default ExpenseBulkEditComponent;
